module.exports = __webpack_public_path__ + "img/inspection.0eb5d777.gif";